module.exports = __webpack_public_path__ + "static/2011-header-a5ab00b8b991e3716eb2291faa07d312.jpg";